import {
  type GetIssueResponseDto,
  type GetUserRolesResponseDto,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { useOutletContext } from 'react-router-dom';

// TODO: this should be a DTO. Will be added in RCP-27788
export type Relationship = {
  id: string;
  code: string;
  type: string;
  title: string;
  link: string;
};

type ContextType = {
  code: string;
  issue: UseQueryResult<GetIssueResponseDto, ExtendedAxiosError>;
  userRoles: UseQueryResult<GetUserRolesResponseDto, ExtendedAxiosError>;
  canDiscardIssue: boolean;
  onDiscardIssue: () => void;
  relationships: Relationship[];
};

export function useIssueOutletContext(): ContextType {
  return useOutletContext<ContextType>();
}
